import { Pipe, PipeTransform } from '@angular/core';
import { Jobrole } from '../../enums/enums';

@Pipe({
    name: 'jobroles',
})
export class JobrolesPipe implements PipeTransform {
    transform(value: number, ...args) {
        switch (value) {
            case Jobrole.administrator:
                return 'Admin';
            case Jobrole.directie:
                return 'Directie';
            case Jobrole.management:
                return 'Management';
            case Jobrole.loonadministratie:
                return 'Loonadministratie';
            case Jobrole.fiatteur:
                return 'Fiatteur';
            case Jobrole.administratie:
                return 'Administratie';
            case Jobrole.secretariaat:
                return 'Secretariaat';
            case Jobrole.verkoop:
                return 'Verkoop';
            case Jobrole.productinnovatie:
                return 'Productinnovatie';
            case Jobrole.werkvoorbereiding:
                return 'Werkvoorbereiding';
            case Jobrole.service_onderhoud:
                return 'Service/Onderhoud';
            case Jobrole.transport_plaatsen:
                return 'Transport/Plaatsen';
            case Jobrole.verhuur_projecten:
                return 'Verhuur/Projecten';
            case Jobrole.facilitair:
                return 'Facilitair';
            case Jobrole.voorman:
                return 'Voorman';
            case Jobrole.productie:
                return 'Productie';
            case Jobrole.urencontrole:
                return 'Uren controle';
            default:
                return 'Onbekend';
        }
    }
}



// WEBPACK FOOTER //
// ./src/pipes/employee-pipe/employee-pipe.ts